<template>
  <div class="w-h-100">
    <div class="app-content" :class="classObj"  v-if="!$route.meta.hiddenNavMenu">
      <new-head></new-head>
      <!-- 左导航固定显示 -->
      <SideBar class="sidebar-container"
              :isBack="isBack" />
      <div class="main-container">
        <div class="app-main">
          <app-main></app-main>
        </div>
      </div>
      <!-- 推送信息组件 -->

      <companyList v-if="!isProjectUser"/>
    </div>
    <app-main v-if="$route.meta.hiddenNavMenu"></app-main>
    <Websocket/>
  </div>
</template>

<script>
import Websocket from '@/components/Websocket'
import { SideBar, AppMain, companyList } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import NewHead from './components/NewHead'
export default {
  name: 'layout',
  data () {
    return {
      isBack: 0
    }
  },
  components: {
    SideBar,
    AppMain,
    NewHead,
    Websocket,
    companyList
    // NavBar,
    // SideBar,
    // TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    classObj () {
      return {
        hideSidebar: this.$store.getters.isCollapse
      }
    },
    isProjectUser () {
      return this.$store.getters.isProjectUser
    }
  },
  created () {
    console.log('Layout')
    window.addEventListener('popstate', function () {
      this.isBack = ++this.isBack
    })
    // 页面刷新, 需要根据token重新获取权限
    // if (this.$route.name && this.$route.name !== 'login') {
    //   this.getAuth()
    // }
  },
  methods: {
    handleClickOutside () {
      // this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
</style>
